import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { PageHeader } from '@ui/layout/Layout/components';
import SSearchInput from '@ui/components/common/SSearchInput';
import { Button, useTheme } from '@mui/material';
import { AddFilled } from '@fluentui/react-icons';
import { FiltersDiscardButton } from '@ui/components/common/buttons';
import ProjectDataGrid from './components/ProjectDataGrid';
import useProjectStyles from './components/ProjectDataGrid/useProjectStyles';
import ProjectDialog from '@ui/components/Dialogs/ProjectDialog';
import { ProjectApi } from '@application/api/endpoints/project-api';
import { convertToLocalTimezone } from '@application/utilities/date-time-formater';
const Projects = () => {
    const theme = useTheme();
    const [isFilterEnabled, setIsFilterEnabled] = useState(false);
    const { addProjectButtonStyles } = useProjectStyles();
    const hasChanges = true;
    const hasNewChanges = isFilterEnabled && hasChanges;
    const [project, setProject] = useState();
    const [refresh, setRefresh] = useState(false);
    const [selectedProject, setSelectedProject] = useState(null);
    const initialFilters = {
        searchTerm: '',
        projectFilter: '',
        projectDescFilter: '',
        startDate: '',
        endDate: ''
    };
    const [projectQuery, setProjectQuery] = useState({
        pageNumber: 1,
        pageSize: 10
    });
    const initialQueryState = {
        searchTerm: '',
        projectFilter: '',
        projectDescFilter: '',
        startDate: null,
        endDate: null
    };
    const [filters, setFilters] = useState(initialFilters);
    const [projectDialog, setProjectDialog] = useState({
        show: false,
        title: '',
        variant: undefined
    });
    const handleEditProjectDialog = (id) => {
        const selectedProject = project?.data.find((project) => project.id === id);
        setSelectedProject(selectedProject);
        setProjectDialog({
            show: true,
            title: 'Edit Project',
            variant: 'edit',
            selectedProjectId: undefined
        });
    };
    const handleOpenProjectDialog = () => {
        setSelectedProject(null);
        setProjectDialog({
            show: true,
            title: 'Create Project',
            variant: 'add',
            selectedProjectId: undefined
        });
    };
    const handleCloseProjectDialog = () => {
        setProjectDialog((prev) => ({
            ...prev,
            show: false,
            title: '',
            variant: undefined
        }));
    };
    const handleEnableFilters = () => {
        setIsFilterEnabled(true);
    };
    const DiscardAndCloseFilters = () => {
        setIsFilterEnabled(false);
        setProjectQuery(initialQueryState);
        setFilters(initialFilters);
    };
    const mapFiltersToQuery = (filters) => {
        return {
            searchTerm: filters.search || undefined,
            projectFilter: filters?.projectName?.trim() || undefined,
            projectDescFilter: filters?.description?.trim() || undefined,
            startDate: filters.startDate ? convertToLocalTimezone(filters.startDate) : undefined,
            endDate: filters.startDate ? convertToLocalTimezone(filters.endDate) : undefined
        };
    };
    useEffect(() => {
        setProjectQuery(() => ({
            ...mapFiltersToQuery(filters)
        }));
    }, [filters]);
    useEffect(() => {
        const getProjects = async () => {
            try {
                const response = await ProjectApi.getFilteredProjectDetail(projectQuery);
                if (response.isSuccess) {
                    setProject(response.data);
                }
            }
            catch (error) {
            }
            finally {
                setRefresh(false);
            }
        };
        getProjects();
    }, [refresh, projectQuery]);
    return (_jsxs(React.Fragment, { children: [_jsx(PageHeader, { title: 'Projects', icons: _jsx(_Fragment, { children: _jsx(Button, { size: 'small', variant: 'contained', color: 'primary', sx: addProjectButtonStyles, children: _jsx(AddFilled, { color: theme.palette.primary.contrastText, fontSize: 20, onClick: handleOpenProjectDialog }) }) }), filters: _jsxs(_Fragment, { children: [_jsx(FiltersDiscardButton, { hasNewChanges: hasNewChanges, handleDiscardFilters: DiscardAndCloseFilters, handleShowFilters: handleEnableFilters }), _jsx(SSearchInput, { onChange: (e) => {
                                setProjectQuery((prev) => ({
                                    ...prev,
                                    searchTerm: e.target.value
                                }));
                            } })] }) }), _jsx(ProjectDataGrid, { rows: project?.data, fullHeight: true, showFilters: isFilterEnabled, onEdit: handleEditProjectDialog, filters: filters, setFilters: setFilters, setRefresh: setRefresh, totalRecords: project?.totalRecords || 0, projectQuery: projectQuery, setProjectQuery: setProjectQuery }), projectDialog.show && (_jsx(ProjectDialog, { isOpen: projectDialog.show, variant: projectDialog.variant, onClose: handleCloseProjectDialog, selectedProject: selectedProject, setRefresh: setRefresh, setSelectedProject: setSelectedProject }))] }));
};
export default Projects;
